/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { EventType } from '@app/common/event/event-type';
import { Event } from '@app/common/event/event';

export const Events = {
  assign: new Event('assign', 'ASSIGN', EventType.REMOTE),
  edit: new Event('edit', 'EDIT', EventType.REMOTE),
  editClose: new Event('editClose', 'EDIT_CLOSE', EventType.REMOTE),
  unassign: new Event('unassign', 'UNASSIGN', EventType.REMOTE),
  autoAdvanceSkipAssign: new Event('autoAdvanceSkipAssign', 'READ_CLOSE_AUTOADVANCE_ASSIGN', EventType.REMOTE),
  autoAdvanceSkipUnAssign: new Event('autoAdvanceSkipUnAssign', 'READ_CLOSE_AUTOADVANCE_UNASSIGN', EventType.REMOTE),
  assignAll: new Event('assignAll', 'ASSIGN', EventType.REMOTE),
  unassignAll: new Event('unassignAll', 'UNASSIGN_ALL', EventType.REMOTE),
  // Dx hub or  PS 360 report discard option initiates this action and removes locks and breaks auto advance
  closediscard: new Event('closediscard', 'READ_CLOSE_DISCARD', EventType.REMOTE),
  offlineuserlockrelease: new Event('offlineuserlockrelease', 'OFFLINE_USER_LOCK_RELEASE', EventType.REMOTE),
  launchDictation: new Event('launchDictation', 'launchDictation', EventType.LOCAL),
  preview: new Event('preview', 'preview', EventType.LOCAL),
  read: new Event('read', 'READ', EventType.REMOTE),
  logout: new Event('logout', 'logout', EventType.LOCAL),
  launchreadonly: new Event('launchreadonly', 'launchreadonly', EventType.LOCAL),
  suspend: new Event('suspend', 'READ_CLOSE_SAVE_FOR_LATER', EventType.REMOTE),
  hyperlinkCreated: new Event('hyperlinkCreated', 'HyperlinkCreated', EventType.LOCAL),

  // User can save and continue working on report in SmartReporting/NativeReporting
  savereport: new Event('savereport', 'SAVE_REPORT', EventType.REMOTE),

  // PS initiates the close , removes locks based on report status and closes Dx hub
  close: new Event('close', 'READ_CLOSE', EventType.REMOTE),
  // PS initiates the close , removes locks always and closes Dx hub
  clear: new Event('clear', 'READ_CLEAR', EventType.REMOTE),
  // Viewer Close initiates the action
  closeviewer: new Event('closeviewer', 'READ_CLOSE_VIEWER', EventType.REMOTE),
  takeControl: new Event('takeControl', 'TAKE_CONTROL', EventType.REMOTE),
  releaseLock: new Event('releaseLock', 'READ_UNLOCK', EventType.REMOTE),
  previewReport: new Event('previewReport', 'previewReport', EventType.LOCAL),
  externalAccessTab: new Event('externalAccessTab', 'externalAccessTab', EventType.LOCAL),
  closeExternalTab: new Event('closeExternalTab', 'closeExternalTab', EventType.LOCAL),
  selectCoReader: new Event('selectCoReader', 'NAW_COREPORT', EventType.REMOTE),
  rejectReport: new Event('rejectReport', 'NAW_REJECT', EventType.REMOTE),
  studyUpdated: new Event('studyUpdated', 'STUDY_UPDATED', EventType.REMOTE),
  studyNotExists: new Event('studyNotExists', 'STUDY_NOT_EXISTS', EventType.REMOTE)
};
